import { render, staticRenderFns } from "./Takeover.vue?vue&type=template&id=30d27fb3&"
import script from "./Takeover.vue?vue&type=script&lang=js&"
export * from "./Takeover.vue?vue&type=script&lang=js&"
import style0 from "./Takeover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports